import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TimelineContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  TimelineContext.displayName = 'TimelineContext';
}

export default TimelineContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/Timeline/TimelineContext.js
// module id = 117
// module chunks = 0